import React from 'react';

import { ReactComponent as IconAssemble } from '../../../assets/customization/values-icons/iconAssemble.svg';
import { ReactComponent as IconBackPainSpecialists } from '../../../assets/customization/values-icons/iconBackPainSpecialists.svg';
import { ReactComponent as IconBrand } from '../../../assets/customization/values-icons/iconBrand.svg';
import { ReactComponent as IconCustomer } from '../../../assets/customization/values-icons/iconCustomer.svg';
import { ReactComponent as IconDelivery } from '../../../assets/customization/values-icons/iconDelivery.svg';
import { ReactComponent as IconExpertise } from '../../../assets/customization/values-icons/iconExpertise.svg';
import { ReactComponent as IconFurnitureDisposal } from '../../../assets/customization/values-icons/iconFurnitureDisposal.svg';
import { ReactComponent as IconGiftCard } from '../../../assets/customization/values-icons/iconGiftCard.svg';
import { ReactComponent as IconGoogle } from '../../../assets/customization/values-icons/iconGoogle.svg';
import { ReactComponent as IconGuarantee } from '../../../assets/customization/values-icons/iconGuarantee.svg';
import { ReactComponent as IconHandMade } from '../../../assets/customization/values-icons/iconHandMade.svg';
import { ReactComponent as IconHighSupportFoundations } from '../../../assets/customization/values-icons/iconHighSupportFoundations.svg';
import { ReactComponent as IconInteriorDesign } from '../../../assets/customization/values-icons/iconInteriorDesign.svg';
import { ReactComponent as IconMedicalDesign } from '../../../assets/customization/values-icons/iconMedicalDesign.svg';
import { ReactComponent as IconPrice } from '../../../assets/customization/values-icons/iconPrice.svg';
import { ReactComponent as IconPrice2 } from '../../../assets/customization/values-icons/iconPrice2.svg';
import { ReactComponent as IconResponsibleMaterials } from '../../../assets/customization/values-icons/iconResponsibleMaterials.svg';
import { ReactComponent as IconStore } from '../../../assets/customization/values-icons/iconStore.svg';
import { ReactComponent as IconYears } from '../../../assets/customization/values-icons/iconYears.svg';
import { ReactComponent as IconPayments } from '../../../assets/customization/values-icons/iconPayments.svg';

export const ICON_MAP: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
    'assemble': IconAssemble,
    'back-pain': IconBackPainSpecialists,
    'brand': IconBrand,
    'customer': IconCustomer,
    'delivery': IconDelivery,
    'expertise': IconExpertise,
    'furniture-disposal': IconFurnitureDisposal,
    'gift-card': IconGiftCard,
    'google': IconGoogle,
    'guarantee': IconGuarantee,
    'hand-made': IconHandMade,
    'high-support': IconHighSupportFoundations,
    'interior-design': IconInteriorDesign,
    'medical-design': IconMedicalDesign,
    'price': IconPrice,
    'price-2': IconPrice2,
    'responsible-materials': IconResponsibleMaterials,
    'store': IconStore,
    'years': IconYears,
    'payments': IconPayments,
};

export const AVAILABLE_ICON_IDS = Object.keys(ICON_MAP);